import * as React from "react";
const SvgFiRrReflect = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-reflect_svg__a)">
      <path
        fill="#062147"
        d="M23 13H1a1 1 0 1 1 0-2h22a1 1 0 0 1 0 2m-4.066-5.874a2.43 2.43 0 0 0-1.284-2.731L9.668.428A3.3 3.3 0 0 0 6.4.433 2.81 2.81 0 0 0 5 2.913V6a3 3 0 0 0 3 3h8.318a2.54 2.54 0 0 0 2.616-1.874M8.737 2.2l8.012 3.98a.42.42 0 0 1 .24.477c-.074.308-.494.34-.671.34H8A1 1 0 0 1 7 6V2.914a.83.83 0 0 1 .418-.758c.18-.104.385-.158.593-.156a1.5 1.5 0 0 1 .726.2m.891 21.394 8.033-3.995a2.425 2.425 0 0 0 1.273-2.726A2.54 2.54 0 0 0 16.318 15H8a3 3 0 0 0-3 3v3.085a2.81 2.81 0 0 0 1.4 2.482A3.2 3.2 0 0 0 8.032 24a3.3 3.3 0 0 0 1.596-.409zM16.318 17c.177 0 .6.032.671.34a.42.42 0 0 1-.229.473L8.7 21.822a1.31 1.31 0 0 1-1.279.02.82.82 0 0 1-.421-.758V18a1 1 0 0 1 1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-reflect_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrReflect;
